import { PendingInquiryDraft } from '@/util/pendingInquiryDraft';

/**
 * Checks if a pending inquiry draft has meaningful data worth preserving.
 * Returns true if the draft has a cancer focus or message content.
 */
export function isMeaningfulData(pendingDraft: PendingInquiryDraft): boolean {
  return !!(pendingDraft.cancerFocusId || pendingDraft.message);
}
